// Bank-rail per-transaction band, mirrored verbatim from the backend's
// IDFCMinAmountMinor / IDFCMaxAmountMinor consts in
// payouts-backend/internal/service/payout/service.go. Pre-validate
// inline so the operator sees the rule before submit instead of
// reserving a needs_approval row that bounces back from the upstream
// rail with code 102 after admin approval.
//
// The backend is the source of truth — these are an optimisation, not
// a security boundary. If the upstream rail changes its band, update
// the backend consts first (the API response also echoes min_minor /
// max_minor on 422 amount_out_of_range), then mirror here.
//
// CLAUDE.md rule 6: amount_minor is bigint (INR paise) end-to-end —
// keep these as bigint so callers don't accidentally compare against a
// Number and silently lose precision past 2^53 paise.

/** ₹300 in paise — the per-payout floor. */
export const PAYOUT_MIN_MINOR = 30_000n;
/** ₹1,00,000 in paise — the per-payout ceiling. */
export const PAYOUT_MAX_MINOR = 10_000_000n;

/**
 * isAmountInPayoutBand returns true iff paise falls within
 * [PAYOUT_MIN_MINOR, PAYOUT_MAX_MINOR]. Pulled out as a tiny helper so
 * the new-payout modal and the CSV validator share one definition —
 * a regression in one path doesn't drift from the other.
 */
export function isAmountInPayoutBand(paise: bigint): boolean {
  return paise >= PAYOUT_MIN_MINOR && paise <= PAYOUT_MAX_MINOR;
}
